import { render, staticRenderFns } from "./AddNewAvoirModal1NewUi.vue?vue&type=template&id=0f8e8255&"
import script from "./AddNewAvoirModal1NewUi.vue?vue&type=script&lang=js&"
export * from "./AddNewAvoirModal1NewUi.vue?vue&type=script&lang=js&"
import style0 from "./AddNewAvoirModal1NewUi.vue?vue&type=style&index=0&lang=css&"
import style1 from "./avoir-request.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports